export default "__VITE_ASSET__eTxnHEkY__"